import { BaseModel, attr, belongsTo, hasMany } from "../../lib/itn-ui-kit/data";

export default class LawfirmModel extends BaseModel {
  @attr("number") pk;
  @attr("number") id;
  @attr("string") name;
  @belongsTo("address") address;
  @attr("string") phone;
  @attr("string") email;
  @attr("string") homepageUrl;
  @attr("boolean") advertising;
  @hasMany("entity") entities;
}
